module.exports = __webpack_public_path__ + "img/history4.5ead4284.jpeg";